import familyListSaga from 'modules/Family/saga/list';
import familyDetailsSaga from 'modules/Family/saga/details';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* familySaga(): SagaIterator {
  yield fork(familyListSaga);
  yield fork(familyDetailsSaga);
}
